<template>
  <div>
    <el-popover
      placement="top-end"
      trigger="hover"
      popper-class="context"
    >
      <pre v-if="hasPostalAndCollectionAccess">{{ $t('FastReceive.HoverTooltip') }}</pre>
      <div v-else>
        {{ $t('FastReceive.NoPermission') }}
      </div>
      <div
        v-if="$isServiceEnabled(49) || $isServiceEnabled(48)"
        slot="reference"
        :class="['fab-button', hasPostalAndCollectionAccess ? '' : 'disabled']"
        @click="openMethodSelDialog"
      >
        <div class="oc">
          <span>{{ $t('FastReceive.QuickLabel') }}</span>
          <span>{{ $t('FastReceive.ReceiveLabel') }}</span>
        </div>
      </div>
    </el-popover>

    <el-dialog
      id="methodSelDialog"
      class="KNS-dialog"
      :visible.sync="methodSelDialog"
      width="900px"
      center
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">{{ $t('FastReceive.SelectVerificationMethod') }}</span>
        </div>
      </span>
      <div class="way-select">
        <ul>
          <li @click="selectBarcode">
            <img
              src="../assets/img/Barcode/barcode.png"
              alt="新增裝置"
            >
            <h3>{{ $t('FastReceive.PhoneBarcode') }}</h3>
          </li>
          <li @click="selectedNFC">
            <img
              src="../assets/img/NFC/nfc.png"
              alt="新增載具"
            >
            <h3>{{ $t('FastReceive.Carrier') }}</h3>
          </li>
          <li @click="householdSwitch=true">
            <img
              src="../assets/img/Tablet/choice_tablet.png"
              alt="新增裝置"
            >
            <h3>{{ $t('FastReceive.DirectSelectHousehold') }}</h3>
          </li>
        </ul>
      </div>
    </el-dialog>

    <el-dialog
      id="receiveDialog"
      class="KNS-OneClick"
      :visible.sync="receiveDialog"
      center
      fullscreen
      @close="closeReceiveDialog"
    >
      <div class="top-wrap">
        <div class="tablet-wrap">
          <span class="title">{{ $t('FastReceive.FastReceive') }}</span>
          <span
            v-if="tablet.length>0"
            class="tabletNote"
          >
            {{ tablet[0].TabletNote }}
            <span v-if="tablet.length>1">...</span>
          </span>
        </div>
        <ul class="btn-wrap">
          <li
            v-if="$isServiceEnabled(49)"
            :class="[receiveTab == 'postal' ? 'active':'','btn']"
            @click="receiveTab='postal'"
          >
            {{ $t('FastReceive.Postal') }}
            <span class="count">{{ postalList.length }}</span>
          </li>
          <li
            v-if="$isServiceEnabled(48)"
            :class="[receiveTab == 'collection' ? 'active':'','btn']"
            @click="receiveTab='collection'"
          >
            {{ $t('FastReceive.Collection') }}
            <span class="count">{{ collectionList.length }}</span>
          </li>
        </ul>
      </div>
      <el-tabs v-model="receiveTab">
        <el-tab-pane
          :label="$t('FastReceive.Postal')"
          name="postal"
          class="tab-body"
        >
          <div class="note-wrap">
            <div class="noteInput">
              <span class="title">{{ $t('FastReceive.ReceiveNote') }}</span>
              <input
                v-model="postalNoteText"
                class="note"
                type="text"
                :placeholder="$t('FastReceive.NotePlaceholder')"
                maxlength="30"
              >
            </div>
            <div class="noteSample">
              <span class="title">{{ $t('FastReceive.InsertTemplateMessage') }}</span>
              <span class="sample-wrap">
                <el-popover
                  v-for="(note,note_ind) in noteSample"
                  :key="note_ind"
                  placement="top"
                  trigger="hover"
                  :content="$t('FastReceive.ClickToInsertNote')"
                  popper-class="dark"
                >
                  <span
                    slot="reference"
                    @click="postalNoteText=note"
                  >{{ note }}</span>
                </el-popover>
              </span>
            </div>
          </div>
          <div class="list-wrap">
            <div class="title-bar">
              <h3>{{ $t('FastReceive.UndeliveredPackageList') }}</h3>
              <el-button
                size="small"
                @click="$refs.postalListTable.clearSelection()"
              >
                {{ $t('FastReceive.ClearSelection') }}
              </el-button>
              <el-button
                size="small"
                @click="filterPackage"
              >
                {{ $t('FastReceive.SearchPostalBarcode') }}
              </el-button>
            </div>
            <div class="list">
              <el-table
                ref="postalListTable"
                :data="postalList"
                border
                style="width: 100%"
                class="KNSDialogTable"
                @selection-change="postalListSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="60"
                  :selectable="postalSelectable"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      :disabled="postalSelectable(scope.row)"
                      :content="$t('FastReceive.InLockerPackageTooltip')"
                      placement="top"
                    >
                      <template #content>
                        <div class="tooltip-content">
                          <div>{{ $t('FastReceive.CannotSelectInLockerPackage') }}</div>
                          <div v-if="$store.state.externalLinks.smartLockerTutorialLink">
                            {{ $t('FastReceive.ClickToView') }}
                            <a :href="$store.state.externalLinks.smartLockerTutorialLink" target="_blank" style="color: #409EFF; text-decoration: underline;">
                              {{ $t('FastReceive.HowToReceiveInLockerPackage') }}
                            </a>
                          </div>
                        </div>
                      </template>
                      <span>
                        <el-checkbox
                          v-model="scope.row.selected"
                          :disabled="!postalSelectable(scope.row)"
                          @change="toggleRow(scope.row)"
                        ></el-checkbox>
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="SerialNum"
                  :label="$t('FastReceive.SerialNumber')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span class="serial-num">{{ scope.row.SerialNum }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('FastReceive.RecipientHouseholdName')"
                  width="300"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.TabletNote }}</div>
                    <div>
                      {{ scope.row.Name + (scope.row.IsPrivacy ? $t('FastReceive.IsPrivacy') : '') }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="PostalTypeName"
                  :label="$t('FastReceive.ReceiveType')"
                  width="200"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.PostalTypeName }}</span>
                    <span
                      v-if="scope.row.IsRefrigerated == 1"
                      class="tag refrigeration"
                    >{{ $t('FastReceive.Refrigerated') }}</span>
                    <span
                      v-if="scope.row.IsRefrigerated == 2"
                      class="tag freezing"
                    >{{ $t('FastReceive.Frozen') }}</span>
                    <span
                      v-if="scope.row.ApplyStorageStatus == 2"
                      class="tag inLocker"
                    >{{ $t('FastReceive.InLocker') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CreateAtUtc"
                  :label="$t('FastReceive.RegistrationTime')"
                  width="130"
                >
                  <template slot-scope="scope">
                    <span>{{ formatDate(scope.row.CreateAtUtc) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="TransportCode"
                  :label="$t('FastReceive.Barcode')"
                  width="130"
                >
                  <template slot-scope="scope">
                    <el-popover
                      placement="top"
                      trigger="hover"
                      :content="scope.row.TransportCode"
                      popper-class="dark"
                    >
                      <span
                        slot="reference"
                      >{{ scope.row.TransportCode.length>7 ? `...${scope.row.TransportCode.slice(-7)}`:scope.row.TransportCode }}</span>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="position"
                  :label="$t('FastReceive.Position')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.Note.indexOf("位置") > -1 ? scope.row.Note.substr(scope.row.Note.indexOf("位置") + 3):'' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="note"
                  :label="$t('FastReceive.Note')"
                  min-width="130"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.Note.indexOf("位置") > -1 ? scope.row.Note.substr(0,scope.row.Note.indexOf("【位置")):scope.row.Note }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('FastReceive.Collection')"
          name="collection"
          class="tab-body"
        >
          <div class="note-wrap">
            <div class="noteInput">
              <span class="title">{{ $t('FastReceive.ReceiveNote') }}</span>
              <input
                v-model="collectionNoteText"
                class="note"
                type="text"
                :placeholder="$t('FastReceive.NotePlaceholder')"
                maxlength="30"
              >
            </div>
            <div class="noteSample">
              <span class="title">{{ $t('FastReceive.InsertTemplateMessage') }}</span>
              <span class="sample-wrap">
                <el-popover
                  v-for="(note,note_ind) in noteSample"
                  :key="note_ind"
                  placement="top-end"
                  trigger="hover"
                  :content="$t('FastReceive.ClickToInsertNote')"
                  popper-class="dark"
                >
                  <span
                    slot="reference"
                    @click="collectionNoteText = note"
                  >{{ note }}</span>
                </el-popover>
              </span>
            </div>
          </div>
          <div class="list-wrap">
            <div class="title-bar">
              <h3>{{ $t('FastReceive.UndeliveredCollectionList') }}</h3>
            </div>
            <div class="list">
              <el-table
                ref="collectionListTable"
                :data="collectionList"
                border
                style="width: 100%"
                class="KNSDialogTable"
                @selection-change="collectionListSelectionChange"
              >
                <el-table-column
                  prop="date"
                  type="selection"
                  width="60"
                />
                <el-table-column label="#" width="90">
                  <template
                    slot-scope="scope"
                  >
                    {{ scope.row.SerialNum != '' && scope.row.SerialNum != null ? 'B' + scope.row.SerialNum : '' }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="TabletNote"
                  :label="$t('FastReceive.Sender')"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.TabletNote != null">
                      <span>{{ scope.row.TabletNote }}</span>
                      <span
                        v-if="scope.row.Username != ''"
                        style="display: block"
                      >{{ `【${scope.row.Username}】` }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="PayTabletNote"
                  :label="$t('FastReceive.Recipient')"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.PayTabletNote != null">
                      <span>{{ scope.row.PayTabletNote }}</span>
                      <span
                        v-if="scope.row.PayUsername != ''"
                        style="display: block"
                      >{{ `【${scope.row.PayUsername}】` }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="TypeDetail"
                  :label="$t('FastReceive.CollectionType')"
                >
                  <template slot-scope="scope">
                    {{ scope.row.TypeDetail == 8 ? $t('FastReceive.Cash') : $t('FastReceive.NonCash') }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="tabletNote"
                  :label="$t('FastReceive.CollectionDetails')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.TypeDetail == 8 ? scope.row.Money : scope.row.TypeDetailName }}</span>
                    <span
                      v-if="scope.row.Type == 1"
                      class="tag refrigeration"
                    >{{ $t('FastReceive.Refrigerated') }}</span>
                    <span
                      v-if="scope.row.Type == 2"
                      class="tag freezing"
                    >{{ $t('FastReceive.Frozen') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="colTime"
                  :label="$t('FastReceive.RegistrationTime')"
                  width="130"
                >
                  <template slot-scope="scope">
                    <span>{{ formatDate(scope.row.CreatedAtUtc) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Location"
                  :label="$t('FastReceive.Position')"
                />
                <el-table-column
                  prop="Note"
                  :label="$t('FastReceive.Note')"
                />
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button
          v-if="signPadAuth"
          :class="[sign!= ''?'active':'']"
          icon="icon-sign"
          @click="signPad"
        >
          {{ $t('FastReceive.ActivateSignaturePad') }}
        </el-button>
        <el-button
          type="primary"
          @click="sendData"
        >
          {{ $t('FastReceive.ConfirmReceive') }}
        </el-button>
      </div>
    </el-dialog>

    <hosuehold-frame
      :open.sync="householdSwitch"
      type="KNS-HK"
      @select-household="selectedHousehold"
    />
    <SignPad ref="signpad" />
    <reader ref="reader" />
    <repeatedOpeningDialog ref="repeatedDialog" />
    <webcam
      ref="webcam"
      :fixed="true"
      :onside="true"
      @takephoto="takephoto"
    />
  </div>
</template>

<script>
import RepeatedOpeningDialog from '@/components/RepeatedOpeningDialog'
import householdFrame from '@/components/HouseholdFrame'
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
import SignPad from '@/components/SignPad'
import WebCam from '@/components/WebCam'
import getSignPadAuth from '@/components/Mixins/getSignPadAuth'
import { FeatureByUser, housekeeperAPI } from '@/api/HousekeeperAPI'
export default {
  components: {
    'hosuehold-frame': householdFrame,
    reader: ReadNFCBarcode,
    SignPad,
    repeatedOpeningDialog: RepeatedOpeningDialog,
    webcam: WebCam
  },
  mixins: [getSignPadAuth],
  data () {
    return {
      postalNoteText: '',
      collectionNoteText: '',
      noteSample: [this.$t('FastReceive.SampleNote1'), this.$t('FastReceive.SampleNote2')],
      receiveTab: 'postal', // 快速領取目前頁面
      methodSelDialog: false, // 驗證方式
      householdSwitch: false, // 戶別選單
      receiveDialog: false, // 快速領取頁面
      tablet: [], // 住戶資訊
      postalList: [], // 郵務列表
      selectedPostalList: [], // 已選取郵務結單列表
      collectionList: [], // 寄放列表
      collectionSelectionList: [], // 以選取寄放結單列表
      sign: '', // 簽名板
      photo: '', // 影像紀錄
      userId: '', // 掃描裝置領取紀錄使用者ID
      NFCCode: '',
      barCode: '',
      hasPostalAndCollectionAccess: false, // 是否有權限點選快速領取
      signPadAuth: false, // 社區是否開啟簽名板功能
      isSmartLockerCommunity: false, // 社區是否有智慧櫃合約社區
      isSending: false // 快速領取郵務、寄放防連點
    }
  },
  computed: {
    receiveType () {
      // 取件類型  0:手機 1:簽名 2:感應 3:直接
      if (this.NFCCode !== '') {
        // 感應扣領取 = 感應
        return 2
      } else if (this.barCode !== '') {
        // 不是感應扣也不是選戶 = 手機
        return 0
      } else if (this.sign !== '') {
        // 選戶 且 有簽名 = 簽名
        return 1
      } else {
        // 選戶 且 沒簽名 = 直接
        return 3
      }
    }
  },
  watch: {
    receiveDialog (now_val) {
      if (!now_val) {
        this.$refs.webcam.closeWebcam()
      }
    },
    methodSelDialog (now_val) {
      if (now_val) {
        this.reSetDefaultValue()
      }
    }
  },
  mounted () {
    this.getCommunityFeaturePermission()
  },
  methods: {
    async getCommunityFeaturePermission () {
      try {
        const { data } = await housekeeperAPI.getFeatureByUser(FeatureByUser.Postal)
        // 管理員擁有郵務寄放的功能權限才能點擊快速領取
        this.hasPostalAndCollectionAccess = data.Data.IsFeature
      } catch (error) {
        console.error(error)
      }
    },
    async getAllData () { // 取得戶別未結單之郵務與寄放
      this.postalList = []
      this.selectedPostalList = []
      this.collectionList = []
      this.collectionSelectionList = []
      this.sign = ''
      this.postalNoteText = ''
      this.collectionNoteText = ''
      const tabletIdList = this.tablet.map(el => el.TabletId)

      const loading = this.$loading({
        lock: true,
        text: this.$t('FastReceive.DataLoading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 拿郵務
      try {
        const { data } = await housekeeperAPI.getPostalUncollectedByTablets(tabletIdList)
        this.postalList = data.Data.Uncollecteds
      } catch (error) {
        console.error(error)
      }
      // 拿寄放
      try {
        const { data } = await housekeeperAPI.getCollectionUncollectedByTablets(tabletIdList)
        this.collectionList = data.Data.Uncollecteds
      } catch (error) {
        console.error(error)
      }
      loading.close()

      if (this.postalList.length === 0 && this.collectionList.length === 0) {
        // 沒有郵務且沒有寄放
        const tabletNoteListString = this.tablet.map(tablet => tablet.TabletNote).join('、')
        this.receiveDialog = true
        this.$alert(this.$t('FastReceive.NoPackageAndCollection', { tabletNoteList: tabletNoteListString }), '', {
          confirmButtonText: this.$t('General.OK'),
          dangerouslyUseHTMLString: true
        }).then(() => {
        }).catch(() => {
        }).finally(() => {
          this.receiveDialog = false
          this.methodSelDialog = false
        })
      } else {
        // 嘗試拍照
        try {
          await this.$refs.webcam.init()
          this.$refs.webcam.getPicture()
        } catch (error) {
          console.error(error)
        }
        this.receiveDialog = true
        this.$nextTick(() => {
          this.$refs.postalListTable.toggleAllSelection()
        })
      }
    },
    selectedHousehold (res) { // 選擇戶別結單
      this.tablet = [res]
      this.householdSwitch = false
      this.methodSelDialog = false
      this.NFCCode = ''
      this.barCode = ''
      this.getAllData()
    },
    selectedNFC () { // 選擇感應扣結單
      // this.methodSelDialog=false
      this.$refs.reader.getCode(async (code) => {
        this.NFCCode = code
        try {
          const { data } = await housekeeperAPI.getHouseholdListByCarrier(code)
          this.barCode = ''
          const fcnInfo = data.Data.CommunityTablets
          if (fcnInfo.length >= 2) {
            this.$refs.repeatedDialog.alert(fcnInfo, callback => {
              this.tablet = []
              if (callback.length > 0) {
                callback.forEach(val => {
                  this.tablet.push({
                    TabletId: val.TabletId,
                    TabletNote: val.TabletNote
                  })
                })
                this.getAllData()
                this.$refs.reader.close()
              } else {
                this.$refs.reader.close()
              }
            }, 'receive')
          } else {
            this.tablet = [{
              TabletId: fcnInfo[0].TabletId,
              TabletNote: fcnInfo[0].TabletNote
            }]
            this.getAllData()
            this.$refs.reader.close()
          }
        } catch (error) {
          console.error(error)
          this.$alert(this.$t('FastReceive.DeviceNotActivated'), '', {
            confirmButtonText: this.$t('General.OK'),
            callback: action => {
              this.$refs.reader.close()
            }
          })
          this.NFCCode = ''
        }
      }, {
        type: 'NFC',
        model: 'basic',
        title: this.$t('FastReceive.PlaceCarrierOnSensor'),
        subtitle: this.$t('FastReceive.AccessCardNote')
      })
    },
    selectBarcode () { // 選擇掃描智生活App 條碼結單
      this.$refs.reader.getCode(async (code) => {
        this.barCode = code
        try {
          const { data } = await housekeeperAPI.getHouseholdListByDeviceCode(code)
          this.NFCCode = ''
          this.tablet = []
          const fcnInfo = data.Data.CommunityTablets
          this.userId = fcnInfo[0].UserId
          fcnInfo.forEach(val => this.tablet.push({ TabletId: val.TabletId, TabletNote: val.TabletNote }))
          this.getAllData()
          this.$refs.reader.close()
        } catch (error) {
          switch (error.response.data.ErrorMessage.Code) {
          case 400000:
            this.$alert(this.$t('FastReceive.BarcodeVerificationError'), this.$t('General.Error'), {
              type: 'error',
              confirmButtonText: this.$t('General.OK'),
              callback: action => {
                this.$refs.reader.close()
              }
            })
            this.barCode = ''
            break
          case 404001:
            this.$alert(this.$t('FastReceive.DeviceNotActivated'), this.$t('FastReceive.Warning'), {
              type: 'warning',
              confirmButtonText: this.$t('General.OK'),
              callback: action => {
                this.$refs.reader.close()
              }
            })
            this.barCode = ''
            break
          default:
            break
          }
        }
      }, 'Barcode')
    },
    postalListSelectionChange (val) { // 郵務列表全選或單選異動後的回調函式
      this.selectedPostalList = val
      this.postalList.forEach((row) => {
        row.selected = this.selectedPostalList.includes(row)
      })
    },
    collectionListSelectionChange (val) { // 寄放列表勾選後的回調函式
      this.collectionSelectionList = val
    },
    signPad () { // 啟動簽名板
      this.$refs.signpad.getSign(res => {
        this.sign = res
      })
    },
    takephoto (url) { // WebCam拍照後回調函式
      this.photo = url
    },
    sendData () { // 確定領取Btn
      const vobj = this
      if (vobj.receiveTab === 'postal' && this.selectedPostalList.length === 0) {
        this.$alert(this.$t('FastReceive.NoItemsSelected'), '', {
          confirmButtonText: this.$t('General.OK'),
          callback: action => { }
        })
        return false
      } else if (vobj.receiveTab === 'collection' && this.collectionSelectionList.length === 0) {
        this.$alert(this.$t('FastReceive.NoItemsSelected'), '', {
          confirmButtonText: this.$t('General.OK'),
          callback: action => { }
        })
        return false
      }

      if (this.signPadAuth && this.sign === '') {
        this.$confirm(this.$t('FastReceive.ContinueToComplete'), this.$t('FastReceive.NotSignedYet'), {
          confirmButtonText: this.$t('General.OK'),
          cancelButtonText: this.$t('General.Cancel'),
          type: 'warning'
        }).then(() => {
          next()
        }).catch(() => {
        })
      } else {
        next()
      }

      function next () {
        console.log(vobj.receiveTab)
        if (vobj.receiveTab === 'postal') {
          vobj.checkOutPostal()
        } else if (vobj.receiveTab === 'collection') {
          vobj.checkOutCollection()
        }
      }
    },
    uploadAllFile (fileName) { // 上傳簽名檔&WebCam
      return new Promise((resolve, reject) => {
        const vobj = this
        const retrunData = {
          handwriteUri: '',
          webcamUri: ''
        }
        const uploadSign = new Promise((resolve, reject) => {
          if (vobj.sign !== '') {
            vobj.$base64Decode(vobj.sign, bs64 => {
              vobj.$uploadFileToFirebase({ file: bs64, folder: 'handwrite', fileName }, img_url => {
                if (img_url !== 'error') {
                  console.log(img_url)
                  retrunData.handwriteUri = img_url
                  resolve()
                } else {
                  reject(new Error('簽名檔上傳失敗'))
                }
              })
            })
          } else {
            resolve()
          }
        })

        const uploadWebcam = new Promise((resolve, reject) => {
          if (vobj.photo !== '') {
            vobj.$base64Decode(vobj.photo, bs64 => {
              vobj.$uploadFileToFirebase({ file: bs64, folder: 'webcam', fileName }, img_url => {
                if (img_url !== 'error') {
                  console.log(img_url)
                  retrunData.webcamUri = img_url
                  resolve()
                } else {
                  reject(new Error('影像紀錄上傳失敗'))
                }
              })
            })
          } else {
            resolve()
          }
        })

        Promise.all([uploadSign, uploadWebcam]).then(() => {
          resolve(retrunData)
        }, (error) => {
          reject(error || new Error('檔案上傳失敗'))
        })
      })
    },
    async checkOutPostal () { // 郵務結單
      if (this.isSending) {
        return
      }
      this.isSending = true
      const loading = this.$loading({
        lock: true,
        text: this.$t('FastReceive.DataTransmitting'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const req = {
          FileName: new Date().getTime().toString(),
          WebcamUrl: '',
          HandwriteUrl: '',
          Note: this.postalNoteText,
          PdIds: this.selectedPostalList.map(val => { return val.PdId }),
          ReceiveType: this.receiveType,
          ReceiveCode: this.barCode || this.NFCCode
        }
        const urlObj = await this.uploadAllFile(req.FileName)
        req.HandwriteUrl = urlObj.handwriteUri
        req.WebcamUrl = urlObj.webcamUri
        await housekeeperAPI.receivePostal(req)
        this.$alert(this.$t('FastReceive.ReceiveSuccess'), '', {
          confirmButtonText: this.$t('General.OK')
        }).then(() => {
          this.getAllData()
          this.$emit('updateHeaderCount')
        }).catch(() => {
        })
      } catch (error) {
        console.error(error)
        Sentry.captureException(error)
        this.$alert(this.$t('FastReceive.ExecutionFailed'), '', {
          confirmButtonText: this.$t('General.OK')
        }).then(() => {
        }).catch(() => {
        })
      } finally {
        this.isSending = false
        loading.close()
      }
    },
    async checkOutCollection () { // 寄放結單
      if (this.isSending) {
        return
      }
      this.isSending = true
      const loading = this.$loading({
        lock: true,
        text: this.$t('FastReceive.DataTransmitting'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const req = {
          FileName: new Date().getTime().toString(),
          HandwriteUrl: '',
          ReceiveCode: this.barCode || this.NFCCode,
          Ids: this.collectionSelectionList.map(val => val.Id),
          Note: this.collectionNoteText,
          ReceiveType: this.receiveType,
          WebcamUrl: ''
        }
        const urlObj = await this.uploadAllFile(req.FileName)
        req.HandwriteUrl = urlObj.handwriteUri
        req.WebcamUrl = urlObj.webcamUri
        await housekeeperAPI.receiveCollection(req)
        this.$alert(this.$t('FastReceive.ReceiveSuccess'), '', {
          confirmButtonText: this.$t('General.OK')
        }).then(() => {
          this.getAllData()
          this.$emit('updateHeaderCount')
        }).catch(() => {
        })
      } catch (error) {
        console.error(error)
        Sentry.captureException(error)
        this.$alert(this.$t('FastReceive.ExecutionFailed'), '', {
          confirmButtonText: this.$t('General.OK')
        }).then(() => {
        }).catch(() => {
        })
      } finally {
        this.isSending = false
        loading.close()
      }
    },
    reSetDefaultValue () { // 重設初始值
      this.postalNoteText = ''
      this.collectionNoteText = ''
      this.receiveTab = this.$isServiceEnabled(49) ? 'postal' : 'collection'
      this.householdSwitch = false
      this.receiveDialog = false
      this.tablet = []
      this.postalList = []
      this.selectedPostalList = []
      this.collectionList = []
      this.collectionSelectionList = []
      this.sign = ''
      this.photo = ''
      this.userId = ''
      this.NFCCode = ''
      this.barCode = ''
    },
    filterPackage () {
      this.$refs.reader.getCode((code) => {
        this.$refs.reader.close()
        this.$refs.postalListTable.clearSelection()
        this.postalList.forEach((val, ind) => {
          if (val.TransportCode === code) {
            this.$refs.postalListTable.toggleRowSelection(val)
          }
        })
      }, 'postal')
    },
    // 開啟驗證方式彈窗
    async openMethodSelDialog () {
      this.receiveTab = this.$isServiceEnabled(49) ? 'postal' : 'collection'
      this.$sendGAEvent('按鈕使用數', {
        value: 'click_快速領取'
      })
      if (this.hasPostalAndCollectionAccess) { this.methodSelDialog = true }
      try {
        this.signPadAuth = await this.getSignPadAuth() // 確認社區是否開啟簽名板功能
        console.log(this.signPadAuth)
      } catch (e) {
        console.log(e)
      }
    },
    // 關閉快速領取頁面
    closeReceiveDialog () {
      console.log('關閉快速領取頁面')
      this.NFCCode = ''
      this.barCode = ''
    },
    toggleRow (row) {
      if (row.selected) {
        this.$refs.postalListTable.toggleRowSelection(row, true)
      } else {
        this.$refs.postalListTable.toggleRowSelection(row, false)
      }
    },
    postalSelectable (row) {
      // 已入櫃不可選取包裹並且顯示提示
      return row.ApplyStorageStatus !== 2
    },
    // 新增checkbox disabled 並且顯示tooltip -- end
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style lang="sass" scoped>
  .KNS-dialog
    ::v-deep .el-dialog
      +KNSDialog
  .KNSDialogTable
    ::v-deep .el-table
      +KNSDialogTable
      &__header
        th
          font-size: 22px
          background-color: $whiteHover
          color: #5f5f5f
          height: 15px
          width: 6px
          &:first-child .cell
            padding-left: 11px
          .el-checkbox__inner
            width: 30px
            height: 30px
            &:after
              left: 50%
              top: 50%
              height: 15px
              width: 6px
              transform: translate(-50%,-50%) rotate(45deg) scaleY(1)
              border-width: 2px
            &:before
              height: 4px
              top: 11px
      &__body
        tr
          > td
            font-size: 20px
            text-align: center
            color: #2f2f2f
            .tag
              padding: 3px 8px 1px
              border-radius: 0
              font-weight: normal
              font-size: 15px
              vertical-align: 1px
              color: #fff
              margin-left: 5px
              &.refrigeration
                background-color: #009cc4
              &.freezing
                background-color: #007b87
              &.inLocker
                background-color: #26958A
            .serial-num
              font-weight: bold
              font-size: 30px
            .el-checkbox__inner
              width: 30px
              height: 30px
              &:after
                left: 50%
                top: 50%
                height: 15px
                width: 6px
                transform: translate(-50%,-50%) rotate(45deg) scaleY(1)
                border-width: 2px
            .el-checkbox.is-disabled .el-checkbox__inner::after,
            .el-checkbox__input.is-disabled .el-checkbox__inner::after
                content: none
                border: none
  .KNS-OneClick
    +KNS-OneClick
  .fab-button
    background: $warnColor
    border-radius: 100%
    width: 80px
    height: 80px
    position: fixed
    bottom: 135px
    right: 30px
    color: white
    transform: translate3d(0, 0, 0)
    transition: transform ease-out 200ms
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)
    cursor: pointer
    z-index: 20
    &:hover
      transform: scale(1.2, 1.2) translate3d(0, 0, 0)
    &.disabled
      cursor: not-allowed
      background: rgba(220,179,163,1)
    .oc
      height: 100%
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      font-size: 24px
      font-weight: 700
  #methodSelDialog
    ::v-deep .el-dialog__body
      padding: 50px 30px
    .way-select
      img
        width: 160px
        height: 160px
        object-fit: contain
        margin-top: 20px
      h3
        font-weight: bold
        color: #5f5f5f
        font-size: 28px
      ul
        padding: 0 !important
        li
          border-color: #ddd
  .tooltip-content
    font-size: 20px
</style>
